/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TAnnouncementsRelevanceConfirmModel = IModel<
  IAnnouncementsRelevanceConfirmRequest,
  TAnnouncementsRelevanceConfirmResponse
>;

export interface IAnnouncementsRelevanceConfirmRequest {
  guid?: string | null;
  notificationType?: ENotificationType | null;
}

export type TAnnouncementsRelevanceConfirmResponse =
  | IAnnouncementsRelevanceConfirmResponse204
  | IAnnouncementsRelevanceConfirmResponse400;

export interface IAnnouncementsRelevanceConfirmResponse204 extends IModelResponse<{}> {
  statusCode: 204;
}

export interface IAnnouncementsRelevanceConfirmResponse400
  extends IModelResponse<IAnnouncementsRelevanceConfirmResponseError> {
  statusCode: 400;
}

export interface IAnnouncementsRelevanceConfirmResponseError {
  errors: any[];
  message: string;
}

export type TResponses = {} | IAnnouncementsRelevanceConfirmResponseError;

export enum ENotificationType {
  /** undefined **/
  Email = 'email',
  /** undefined **/
  Lk = 'lk',
  /** undefined **/
  Report = 'report',
  /** undefined **/
  Site = 'site',
  /** undefined **/
  Chat = 'chat',
  /** undefined **/
  Ivr = 'ivr',
  /** undefined **/
  Sms = 'sms',
  /** undefined **/
  Popup = 'popup',
  /** undefined **/
  Hlr = 'hlr',
  /** undefined **/
  WhatsApp = 'whatsApp',
}

export interface IMappers<TResponse204, TResponse400> {
  204(): TResponse204;
  400(response: IAnnouncementsRelevanceConfirmResponseError): TResponse400;
}
